import React, {useCallback} from 'react';
import styles from './VehicleForm.module.scss';
import {Checkbox, InputGroup} from 'components';
import Car from 'assets/images/auto.png';
import Bike from 'assets/images/moto.png';
import Radio from 'components/style-guide/form/radio/Radio';
import AddIcon from 'components/style-guide/icons/Add.icon';
import clsx from 'clsx';
import Trash from 'components/style-guide/icons/Trash';
import FormikInput from 'components/style-guide/form/formik-input/FormikInput';
import {FieldArray, useField} from 'formik';
import {formatPatent} from 'shared';
import AppSettings from 'settings/app-settings';
import {chileCurrency} from 'shared/utils';

export const VehicleForm = (props) => {
    const {
        patentes, price = AppSettings.priceReport, className, setFieldValue
    } = props;

    const label = 'Patente', name = 'patentes';
    const onChangePatent = useCallback((patentName, patent, type) => {
        setFieldValue(patentName, patent.reportType?.includes(type) ? patent.reportType?.filter(t => t !== type) : [...(patent.reportType ?? []), type])
    }, [setFieldValue]);

    const [_, meta] = useField(name);

    return (<div className={clsx('pb-4', styles.formContainer, className)}>
            <p className="form-title">Datos Vehiculares</p>
            <FieldArray
                name="patentes"
                render={(arrayHelpers) => (<div>
                        <div className={styles.patentsContainer}>
                            {patentes.map((patent, index) => {
                                const reportTypeError = meta.touched && meta.error && meta.error?.[index]?.reportType;
                                return (<div key={index}
                                             className={clsx('form-group mb-1', styles.vehicleContainer)}>
                                        <FormikInput
                                            Component={InputGroup}
                                            inputClassName={clsx('flex-fill mb-0', styles.patentInputContainer)}
                                            wrapperClassName={''}
                                            required
                                            helpLabel="Ingrese la patente sin el dígito verificador."
                                            placeholder="Patente"
                                            trailing={true}
                                            trailingTpl={<>
                                                <div className="input-group-append">
                                                      <span className={clsx('input-group-text')}
                                                            style={{borderRadius: '0 0.25rem 0.25rem 0'}}>
                                                        <p className="m-0"
                                                           style={{color: 'red'}}>{patent.reportType?.length > 0 ? chileCurrency(price) : chileCurrency(0)}</p>
                                                      </span>
                                                </div>
                                                {patentes.length > 1 && (
                                                    <span className="d-flex align-items-center px-1">
                                                          <Trash
                                                              onClick={() => arrayHelpers.remove(index)}
                                                              className="btn-clear"
                                                              style={{color: '#374151'}}/>
                                                        </span>)}
                                            </>}
                                            label={label}
                                            name={`${name}.${index}.patente`}
                                            setFormat={(v, event) => {
                                                try {
                                                    setFieldValue(`${name}.${index}.patente`, formatPatent(v));
                                                } catch (e) {}
                                            }}
                                        />
                                        <div>
                                            <div className="pt-2 inline-block text-height-0">
                                                <FormikInput
                                                    wrapperClassName={''}
                                                    Component={Radio}
                                                    value="car"
                                                    name={`${name}.${index}.vehicle`}
                                                    checked={patentes[index] && 'car' === patentes[index].vehicle}
                                                    id={`car${index}`}
                                                    radioClassName={styles.customRadioSize}
                                                    label=""
                                                    labelTpl={<img src={Car} alt="Auto" className="px-0"/>}
                                                />
                                            </div>
                                            <div className="pt-2 inline-block text-height-0">
                                                <FormikInput
                                                    wrapperClassName={''}
                                                    Component={Radio}
                                                    value="bike"
                                                    name={`${name}.${index}.vehicle`}
                                                    checked={patentes[index] && 'bike' === patentes[index].vehicle}
                                                    id={`bike${index}`}
                                                    radioClassName={styles.customRadioSize}
                                                    label=""
                                                    labelTpl={<img src={Bike} alt="Moto" className="px-0"/>}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <p className="mb-2 flex gap-1">
                                                <span className="required">*</span>
                                                <span>Tipo de Reporte</span>
                                            </p>
                                            <div className={styles.reportType}>
                                                <Checkbox
                                                    error={reportTypeError}
                                                    className=""
                                                    label="Completo"
                                                    checked={patent.reportType?.includes('COMPLETE')}
                                                    onChange={() => onChangePatent(`${name}.${index}.reportType`, patent, 'COMPLETE')}/>
                                                {/* <Checkbox
                                                    error={reportTypeError}
                                                    className=""
                                                    label="Anónimo"
                                                    checked={patent.reportType?.includes('ANONYMOUS')}
                                                    onChange={() => onChangePatent(`${name}.${index}.reportType`, patent, 'ANONYMOUS')}/> */}
                                            </div>
                                        </div>

                                        {reportTypeError && <small
                                            className={clsx('form-text is-invalid invalid-feedback d-flex')}>{meta.error?.[index]?.reportType}</small>}
                                    </div>)
                            })}
                        </div>
                        <button
                            onClick={() => arrayHelpers.push({
                                vehicle: 'car', patente: undefined, reportType: ['COMPLETE']
                            })}
                            className={clsx('btn btn-clear text-nowrap pr-2 py-0 my-0', styles.addPatente)}
                            style={{paddingLeft: '0px'}}>
                            <span className="inline-icon pr-1"> <AddIcon fontSize="small"/> </span>
                            <span className="buttonText" style={{color: 'var(--primary)'}}>Agregar otra Patente</span>
                        </button>
                    </div>)}
            />
        </div>);
};

VehicleForm.propTypes = {};

export default React.memo(VehicleForm);
